import React from "react";
import classnames from "classnames";
import { Address } from "@eave/shared/components/Address";
import { AppShape } from "@eave/shared/types/api";
import { formatCurrency } from "@eave/shared/utils/currency";

const { FormattedDate } = require("react-intl");

const styles = require("./styles.module.scss");

interface Props {
  app: AppShape;
  isVisible: boolean;
  navExpanded: boolean;
}

const placeholder = <>&mdash;</>;

const formatName = (firstName, middleName, lastName, suffix) =>
  `${firstName}${middleName ? ` ${middleName} ` : " "}${lastName}${suffix ? `, ${suffix}` : ""}`;

const AppSlimDetails: React.FC<Props> = ({ app, isVisible, navExpanded }: Props) => {
  const address = {
    line1:
      app.computed_properties.purchased_property_address &&
      app.computed_properties.purchased_property_address.line1,
    line2:
      app.computed_properties.purchased_property_address &&
      app.computed_properties.purchased_property_address.line2,
    city:
      app.computed_properties.purchased_property_address &&
      app.computed_properties.purchased_property_address.city,
    state:
      app.computed_properties.purchased_property_address &&
      app.computed_properties.purchased_property_address.state,
    zip:
      app.computed_properties.purchased_property_address &&
      app.computed_properties.purchased_property_address.postal_code.split("-")[0],
  };

  const wrapperStyles = classnames({
    [styles.slimHeaderWrapper]: true,
    [styles.shouldAppear]: isVisible,
    [styles.navExpanded]: navExpanded,
    [styles.employeeHeader]: app.restricted,
  });

  return (
    <div className={wrapperStyles}>
      <header className={styles.slimHeader}>
        <div>
          <span>
            Loan #: <strong>{app.computed_properties.loan_number || placeholder}</strong>{" "}
          </span>
          <span>
            Lead #: <strong>{app.computed_properties.lead_number || placeholder}</strong>{" "}
          </span>
          <span>
            B1:{" "}
            <strong>
              {" "}
              {formatName(
                app.borrower1_first_name,
                app.borrower1_middle_name,
                app.borrower1_last_name,
                app.borrower1_suffix,
              )}
            </strong>
          </span>
          <span>
            B2:{" "}
            <strong>
              {app.has_borrower2
                ? formatName(
                    app.borrower2_first_name,
                    app.borrower2_middle_name,
                    app.borrower2_last_name,
                    app.borrower2_suffix,
                  )
                : "n/a"}
            </strong>
          </span>
          <span>
            Property:{" "}
            <strong>
              {app.computed_properties.purchased_property_address &&
              app.computed_properties.purchased_property_address.line1 ? (
                <Address address={address} />
              ) : (
                placeholder
              )}
            </strong>
          </span>
          <span>
            Purchase price:{" "}
            <strong>
              {formatCurrency(app.computed_properties.purchase_price, 2, 2) || placeholder}
            </strong>
          </span>
          <span>
            Closing:{" "}
            <strong>
              {app.computed_properties.closing_date ? (
                <FormattedDate
                  value={app.computed_properties.closing_date}
                  year="numeric"
                  month="numeric"
                  day="numeric"
                  timeZone="UTC"
                />
              ) : (
                placeholder
              )}
            </strong>
          </span>
          {app.restricted && (
            <span style={{ fontSize: "32px" }}>
              <i className="fa fa-id-badge" title="Employee Loan" />
            </span>
          )}
        </div>
      </header>
    </div>
  );
};

export default AppSlimDetails;
